import { render, staticRenderFns } from "./DiscoverView.vue?vue&type=template&id=52de3005"
import script from "./DiscoverView.vue?vue&type=script&lang=js"
export * from "./DiscoverView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports